module.exports = "../content/0be9fa8f2863998d1e52c84165976880.ttf";